var map = {
	"./Krishnas-lotus-feet.png": 2510,
	"./art_of_mind_control.png": 3554,
	"./art_of_mind_control_dashboard.png": 7742,
	"./auto_attendance.png": 1421,
	"./auto_attendance_dashboard.png": 5297,
	"./bad.png": 772,
	"./beverage.png": 897,
	"./bits.png": 4219,
	"./bitter.png": 2723,
	"./breakfast.png": 117,
	"./chutney.png": 3676,
	"./club_reg.png": 1847,
	"./club_reg_dashboard.png": 3802,
	"./daal.png": 3409,
	"./dinner.png": 5881,
	"./dosa.png": 5793,
	"./event.png": 9062,
	"./event_dashboard.png": 6944,
	"./festival_event.png": 5615,
	"./folklogo.png": 3108,
	"./fph.png": 276,
	"./gcb.png": 3370,
	"./geeta_for_youth.png": 9715,
	"./geeta_for_youth_dashboard.png": 9030,
	"./good.png": 8243,
	"./hard to eat.png": 9083,
	"./idli.png": 4288,
	"./iit.png": 6712,
	"./insect.png": 2588,
	"./kkp.png": 502,
	"./kphb.png": 7456,
	"./less salt.png": 2215,
	"./less sweet.png": 2073,
	"./mdh.png": 2467,
	"./missing.png": 3059,
	"./more sweet.png": 6674,
	"./more water.png": 7372,
	"./msb.png": 9230,
	"./no-old.png": 41,
	"./no.png": 3282,
	"./nrg.png": 2846,
	"./nsi.png": 7686,
	"./oily.png": 5002,
	"./ok-old.png": 1054,
	"./ok.png": 47,
	"./pgn.png": 2353,
	"./received late.png": 9976,
	"./report.png": 9050,
	"./report_dashboard.png": 837,
	"./rice.png": 413,
	"./roti.png": 4676,
	"./sabji.png": 7788,
	"./salty.png": 8785,
	"./single bed occupied.png": 7477,
	"./single bed oos.png": 3362,
	"./single bed vacant old.png": 804,
	"./single bed vacant.png": 5400,
	"./snack.png": 9480,
	"./sour.png": 6932,
	"./spicy.png": 9718,
	"./spoiled.png": 6493,
	"./srn.png": 964,
	"./sunday_meetup.png": 2636,
	"./sunday_meetup_dashboard.png": 9282,
	"./sweet.png": 8055,
	"./uncooked.png": 2744,
	"./upma.png": 709,
	"./vrindavan-accommodation.png": 6919,
	"./yes-old.png": 7495,
	"./yes.png": 8572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;